<template lang="html">

  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/juridical')" style="cursor: pointer">Jurídico</li>
        <li class="breadcrumb-item active" aria-current="page">Catálogos</li>
        <li class="breadcrumb-item active" aria-current="page">Contratos</li>
      </ol>
    </nav>

    <div class="container-fluid">
      <div class="row" style="margin-bottom: 1em">
        <div class="col-md-12">
          <md-card>
            <md-card-header>
              <div class="md-title">Filtros</div>
            </md-card-header>
            <md-card-content>
              <md-table>
                <md-table-row>
                  <md-table-cell>
                    <md-field>
                      <label>Grupo de Contrato</label>
                      <md-select v-model="selected_contract_groups" multiple>
                        <md-option v-for="cg in filter_contract_groups" :value="cg.id" v-bind:key="cg.id">{{cg.name}}</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Tipo de Contrato</label>
                      <md-select v-model="selectedTypes" multiple>
                        <md-option v-for="type in types" :value="type.id" v-bind:key="type.id">{{type.name}}</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Versión</label>
                      <md-select v-model="selectedVersions" multiple>
                        <md-option v-for="version in versions" :value="version" v-bind:key="version">{{version}}</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell>
                    <md-checkbox v-model="splits" class="md-primary">Para Fraccionado</md-checkbox>
                  </md-table-cell>
                  <md-table-cell>
                    <md-checkbox v-model="active" class="md-primary">Activos</md-checkbox>
                  </md-table-cell>
                  <md-table-cell>
                    <md-button class="md-raised md-primary" @click="limpiarFiltros()">Limpiar</md-button>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </md-card>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <md-card>
            <md-card-header>
              <div class="md-title">Contratos
                <md-button class="md-icon-button md-raised md-primary" style="background-color: green; float: right" v-on:click="editContract='New'">
                  <md-icon>add</md-icon>
                </md-button>
              </div>
            </md-card-header>
            <md-card-content>
              <md-table>
                <md-table-row>
                  <md-table-head>ID</md-table-head>
                  <md-table-head>Contrato Padre</md-table-head>
                  <md-table-head>Grupo de Contratos</md-table-head>
                  <md-table-head>Nombre</md-table-head>
                  <md-table-head>Versión</md-table-head>
                  <md-table-head>Descripción</md-table-head>
                  <md-table-head>Tipo</md-table-head>
                  <md-table-head>Para Fraccionado</md-table-head>
                  <md-table-head>Activo</md-table-head>
                  <md-table-head style="text-align: center">Editar | Borrar | Archivo</md-table-head>
                </md-table-row>
                <md-table-row v-if="editContract==='New'">
                  <md-table-cell>{{editContract}}</md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Contrato Padre</label>
                      <md-select v-model="contract_parent">
                        <md-option :value="cp.id" v-for="cp in contracts" :key="cp.id">{{cp.name}}</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Grupo de Contratos</label>
                      <md-select v-model="contract_group">
                        <md-option :value="cg.id" v-for="cg in contract_groups" :key="cg.id">{{cg.name}}</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Nombre</label>
                      <md-textarea v-model="name" md-autogrow/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Versión</label>
                      <md-textarea v-model="version" md-autogrow/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Descripción</label>
                      <md-textarea v-model="description" md-autogrow/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Tipo</label>
                      <md-select v-model="type">
                        <md-option :value="t.id" v-for="t in types" :key="t.id">{{t.name}}</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>

                  <md-table-cell style="text-align: center">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="for_split"/>
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>

                  <md-table-cell style="text-align: center">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="status"/>
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>

                  <md-table-cell style="width: 16%;text-align: center">
                    <md-button class="md-icon-button md-mini md-raised" v-on:click="guardarContract()">
                      <md-icon>save</md-icon>
                    </md-button>
                    <md-button class="md-icon-button md-mini md-raised md-accent" v-on:click="limpiar()">
                      <md-icon>clear</md-icon>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
                <md-table-row v-for="contract in filtered_contracts" :key="contract.id">
                  <md-table-cell>{{contract.id}}</md-table-cell>

                  <md-table-cell v-if="editContract===contract.id">
                    <md-field>
                      <label>Contrato Padre</label>
                      <md-select v-model="contract_parent">
                        <md-option :value="cp.id" v-for="cp in contracts" :key="cp.id">{{cp.name}}</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{contract.contract_parent}}</md-table-cell>

                  <md-table-cell v-if="editContract===contract.id">
                    <md-field>
                      <label>Grupo de Contratos</label>
                      <md-select v-model="contract_group">
                        <md-option :value="cg.id" v-for="cg in contract_groups" :key="cg.id">{{cg.name}}</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{contract.contract_group}}</md-table-cell>

                  <md-table-cell v-if="editContract===contract.id">
                    <md-field>
                      <label>Nombre</label>
                      <md-textarea v-model="name" md-autogrow/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{contract.name}}</md-table-cell>

                  <md-table-cell v-if="editContract===contract.id">
                    <md-field>
                      <label>Versión</label>
                      <md-textarea v-model="version" md-autogrow/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{contract.version}}</md-table-cell>

                  <md-table-cell v-if="editContract===contract.id">
                    <md-field>
                      <label>Descripción</label>
                      <md-textarea v-model="description" md-autogrow/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{contract.description}}</md-table-cell>

                  <md-table-cell v-if="editContract===contract.id">
                    <md-field>
                      <label>Tipo</label>
                      <md-select v-model="type">
                        <md-option :value="t.id" v-for="t in types" :key="t.id">{{t.name}}</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{getType(contract.type)}}</md-table-cell>

                  <md-table-cell style="text-align: center" v-if="editContract===contract.id">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="for_split"/>
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>
                  <md-table-cell v-else style="text-align: center">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="contract.for_split" disabled/>
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>

                  <md-table-cell style="text-align: center" v-if="editContract===contract.id">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="status"/>
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>
                  <md-table-cell v-else style="text-align: center">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="contract.status" disabled/>
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>

                  <md-table-cell style="width: 20%;text-align: center" v-if="editContract===contract.id">
                    <md-button class="md-icon-button md-mini md-raised" v-on:click="guardarContract()">
                      <md-icon>save</md-icon>
                    </md-button>
                    <md-button class="md-icon-button md-mini md-raised md-accent" v-on:click="limpiar()">
                      <md-icon>clear</md-icon>
                    </md-button>
                  </md-table-cell>
                  <md-table-cell v-else style="width: 20%;text-align: center">
                    <md-button class="md-icon-button md-mini md-raised md-primary" v-on:click="editarContract(contract)">
                      <md-icon>edit</md-icon>
                    </md-button>
                    <md-button class="md-icon-button md-mini md-raised md-accent" v-on:click="borrarContract(contract.id)">
                      <md-icon>delete</md-icon>
                    </md-button>
                    <md-button class="md-icon-button md-mini md-raised" v-on:click="verFileDialog(contract)">
                      <md-icon>content_paste</md-icon>
                    </md-button>
                  </md-table-cell>

                </md-table-row>
              </md-table>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>

    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title v-if="contract != null">Documento Base <strong><u>{{contract.name}} v.{{contract.version}}</u></strong> (Formato Word)</md-dialog-title>
      <md-dialog-content v-if="contract != null">
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary md-raised" @click="cerrarFileDialog()">CERRAR</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>

</template>

<script lang="js">

  export default  {
    name: 'contracts',
    props: [],
    mounted () {
      this.getContracts();
      axios.get( '/api/catalogs/contract_groups').then(response => {
        this.contract_groups = response.data.data;
      });
    },
    data () {
      return {
        contract_groups: [],
        contracts: [],
        filtered_contracts:[],
        types: [
          {id:1,name:'Términos y Condiciones'},
          {id:2,name:'Aviso de Privacidad'},
          {id:3,name:'Comisión Mercantil Inversionista'},
          {id:4,name:'Comisión Mercantil Cliente (Solicitante)'},
          {id:5,name:'Comisión Mercantil Proveedor'},
          {id:6,name:'Crédito Simple'},
          {id:7,name:'Pagaré'},
          {id:8,name:'Prenda en Garantía'},
          {id:9,name:'Arrendamiento Financiero'},
          {id:10,name:'Bienes Arrendados'},
          {id:11,name:'Compra Venta'},
          {id:12,name:'Carta de Entendimiento'},
          {id:13,name:'Domiciliación'},
        ],

        showDialog: false,
        contract: null,

        editContract: null,
        contract_parent: null,
        contract_group: null,
        name: null,
        version: null,
        description: null,
        type: null,
        for_split: null,
        status: null,

        filter_contract_groups: [],
        selected_contract_groups: [],
        versions: [],
        selectedVersions: [],
        selectedTypes: [],
        splits: false,
        active: false,

      }
    },
    methods: {
      getType(type){
        var t = this.types.filter(item => {return item.id === type});
        return t[0].name;
      },
      limpiar(){
        this.editContract = null;
        this.contract_parent = null;
        this.contract_group = null;
        this.name = null;
        this.version = null;
        this.description = null;
        this.type = null;
        this.for_split = null;
        this.status = null;
      },
      getContracts(){
        axios.get( '/api/catalogs/contracts').then(response => {
          this.contracts = response.data.data;
          this.filtered_contracts = response.data.data;
          var flags = [], cv = [], cg = [], l = this.contracts.length, i;
          for( i=0; i<l; i++) {
            if( flags[this.contracts[i].version]) continue;
            flags[this.contracts[i].version] = true;
            cv.push(this.contracts[i].version);
          }
          this.versions = cv;

          flags = [], cg = [], i;
          for( i=0; i<l; i++) {
            if( flags[this.contracts[i].contract_group_id]) continue;
            flags[this.contracts[i].contract_group_id] = true;
            cg.push({
              id: this.contracts[i].contract_group_id,
              name: this.contracts[i].contract_group == null ? 'Sin especificar' : this.contracts[i].contract_group,
            })
          }
          this.filter_contract_groups = cg;

          this.filtrarContratos();
        });
      },
      guardarContract(){
        Vue.toasted.show('Guardando Contrato...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post( '/api/catalogs/contracts/save', {
          'contract_id': this.editContract === 'New' ? -1 : this.editContract,
          'contract_parent_id': this.contract_parent,
          'contract_group_id': this.contract_group,
          'name': this.name,
          'version': this.version,
          'description': this.description,
          'type': this.type,
          'for_split': this.for_split,
          'status': this.status,
        }).then(response => {
          this.limpiar();
          this.getContracts();
          Vue.toasted.clear();
          Vue.toasted.show('¡¡ Contrato guardado correctamente !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },
      editarContract(contract){
        this.editContract = contract.id;
        this.contract_parent = contract.contract_parent_id;
        this.contract_group = contract.contract_group_id;
        this.name = contract.name;
        this.version = contract.version;
        this.description = contract.description;
        this.type = contract.type;
        this.for_split = contract.for_split;
        this.status = contract.status;
      },
      borrarContract(cid) {
        Vue.toasted.show('Borrando Contrato...', {position: 'bottom-center', closeOnSwipe: false});
        axios.post('/api/catalogs/contracts/delete', {
          'contract_id': cid,
        }).then(response => {
          this.getContracts();
          Vue.toasted.clear();
          Vue.toasted.show('¡¡ Contrato borrado correctamente !!', {position: 'bottom-center', type: 'success', closeOnSwipe: false, duration: 10000
          });
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', {position: 'bottom-center', type: 'error', closeOnSwipe: true, duration: 10000
          });
        });
      },
      verFileDialog(contract){
        this.showDialog = true;
        this.contract = contract;
      },
      cerrarFileDialog(){
        this.showDialog = false;
      },
      filtrarContratos(){
        this.filtered_contracts = this.contracts;
        if(this.splits){
          this.filtered_contracts = this.filtered_contracts.filter(item => {return item.for_split == 1})
        }
        if(this.active){
          this.filtered_contracts = this.filtered_contracts.filter(item => {return item.status == 1})
        }
        if(this.selected_contract_groups.length > 0){
          this.filtered_contracts = this.filtered_contracts.filter(item => {return this.selected_contract_groups.includes(item.contract_group_id)})
        }
        if(this.selectedVersions.length > 0){
          this.filtered_contracts = this.filtered_contracts.filter(item => {return this.selectedVersions.includes(item.version)})
        }
        if(this.selectedTypes.length > 0){
          this.filtered_contracts = this.filtered_contracts.filter(item => {return this.selectedTypes.includes(item.type)})
        }
      },
      limpiarFiltros(){
        this.splits = false;
        this.active = false;
        this.selected_contract_groups = [];
        this.selectedVersions = [];
        this.selectedTypes = [];
      }
    },
    watch: {
      selected_contract_groups: function(){
        this.filtrarContratos();
      },
      selectedVersions: function(){
        this.filtrarContratos();
      },
      selectedTypes: function(){
        this.filtrarContratos();
      },
      splits: function(){
        this.filtrarContratos();
      },
      active: function(){
        this.filtrarContratos();
      },
    }
}


</script>

<style scoped>
  /* Customize the label (the container) */
  .container {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 35px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default checkbox */
  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #eee;
    margin-left: 30%;
    border-radius: 30px;
  }

  /* On mouse-over, add a grey background color */
  .container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */
  .container input:checked ~ .checkmark {
    background-color: rgb(243, 205, 33);
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .container input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .container .checkmark:after {
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
</style>